import React, { useState } from 'react';
import { TableCellsIcon } from '@heroicons/react/24/outline';
import { ExportCard } from '../ExportCard';
import { exportAllocationsList } from '../../services';

interface AllocationsListExportCardProps {
    onError: (message: string | null) => void;
}

/**
 * Exportação detalhada: uma linha por alocação, com colaborador, cliente,
 * projeto, tipo de escopo, data de início e data de fim.
 */
export const AllocationsListExportCard: React.FC<AllocationsListExportCardProps> = ({
    onError,
}) => {
    const [isExporting, setIsExporting] = useState(false);
    const [progressLabel, setProgressLabel] = useState<string | null>(null);

    const handleExport = async () => {
        setIsExporting(true);
        setProgressLabel(null);
        onError(null);

        try {
            const rowCount = await exportAllocationsList((loaded, total) =>
                setProgressLabel(`Lendo alocações (${loaded}/${total})...`)
            );

            if (rowCount === 0) {
                onError('Nenhuma alocação encontrada para exportar.');
            }
        } catch (error) {
            console.error('Erro ao exportar alocações:', error);
            onError('Falha ao gerar a exportação detalhada de alocações. Tente novamente.');
        } finally {
            setIsExporting(false);
            setProgressLabel(null);
        }
    };

    return (
        <ExportCard
            title="Alocações (Detalhado)"
            description="Uma linha por alocação: colaborador, cliente, projeto, tipo de escopo, data de início e data de fim."
            icon={TableCellsIcon}
            isExporting={isExporting}
            progressLabel={progressLabel}
            onExport={handleExport}
        />
    );
};

export default AllocationsListExportCard;
